import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import InsertData from "./InsertCompanies";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { deleteAlert, errorAlert, handleSuccess, updateAlert } from "../../Components/Alerts";
import Modal_bootstrap from 'react-bootstrap/Modal';
import { Typography, Modal } from '@mui/material';
import Button from 'react-bootstrap/Button';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillEdit } from "react-icons/ai";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Paper } from "@mui/material";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { MdAddBusiness } from "react-icons/md";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import Box from '@mui/material/Box';
import FormControl from "@mui/material/FormControl";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MUI_Button from "@mui/material/Button";
import AddIcon from '@mui/icons-material/Add';
import { AddLinkButton } from "../../Components/AddElementsButton";
import { LICENSE_STATUS, PAYMENT_STATUS } from "../../OtherData/LicenseData";

export default function Companies() {

    const headers = authHeader();
    const loginEmail = LoginUserDetailed();
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        CompanyID: "",
        CompanyName: "",
        IdentificationNumber: "",
        VATNumber: "",
        Address: "",
        CityID: "",
        StateID: "",
        PhoneNumbers: "",
        EdiPass: "",
        ARBKPass: "",
        MailPass: "",
        SMTPClient: "",
        Email: "",
        Comment: "",
        ModifiedByUser: "",
        VATDeclarant: "",
        FiscalYear: "",
        IsActive: "",
        CompanyLogo: "anonymous.png",
        LogoPath: ApiLink.PHOTO_URL
    })

    const [openPackModal, setOpenPackModal] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [city, setCity] = useState([]);
    const [state, setState] = useState([]);
    let number = 1;
    const [role, setRole] = useState("");

    const [insertType, setInsertType] = useState("");

    const [pack, setPack] = useState([]);
    const [companyName, setCompanyName] = useState('');
    const [companyID, setCompanyID] = useState('');
    const [packID, setPackID] = useState('');
    const [packName, setPackName] = useState('');

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies', { headers });
            setData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyAndLicense', { headers });
    //         const data = response.data;

    //         // Shembull: nëse ke një company object me licenseStatusId dhe paymentStatusId
    //         const mappedData = data.map((item) => {
    //             return {
    //                 ...item,
    //                 licenseStatus: item.Status
    //                     ? (LICENSE_STATUS.find(s => s.id === item.Status)?.label ?? "Nuk ka licens")
    //                     : "Nuk ka licens",

    //                 paymentStatus: item.PaymentStatus
    //                     ? (PAYMENT_STATUS.find(s => s.id === item.PaymentStatus)?.label ?? "Nuk ka licens")
    //                     : "Nuk ka licens",

    //             };
    //         });

    //         setData(mappedData);
    //         setLoading(false);

    //     } catch (error) {
    //         errorAlert("Gabim në kërkesë:", error);

    //         if (error.response?.data?.errorMessage) {
    //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
    //         } else if (error.message) {
    //             errorAlert(`Gabim: ${error.message}`);
    //         } else {
    //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
    //         }
    //     }
    // };

    const fetchPack = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'PackContoller', { headers });
            setPack(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // const handleSubmitCompanyPack = (event) => {
    //     event.preventDefault();

    //     // Validimi i `packID` dhe `companyID`
    //     if (!packID || packID === '') {
    //         errorAlert("Ju lutem zgjedhni pakon");
    //         return;
    //     }
    //     if (!companyID || companyID === '') {
    //         errorAlert("Ju lutem zgjedhni kompaninë");
    //         return;
    //     }

    //     const stateData = {
    //         CompanyID: companyID,
    //         PackID: packID
    //     };

    //     axios.post(ApiLink.API_URL + 'PackContoller', stateData, { headers })
    //         .then((response) => {
    //             handleSuccess("Pako u regjistrua me sukses tek kompania");
    //             setPackID("");
    //             setCompanyID("");
    //             setOpenPackModal(false);
    //             fetchData();
    //         })
    //         .catch((error) => {
    //             if (error.response) {
    //                 if (error.response.status === 409) {
    //                     errorAlert(error.response.data);
    //                 } else if (error.response.status === 400) {
    //                     errorAlert("Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri.");
    //                 } else if (error.response.status === 500) {
    //                     errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
    //                 }
    //             } else {
    //                 errorAlert("Gabim i panjohur ndodhi gjatë përpunimit të kërkesës.");
    //             }
    //         });
    // };

    const handleUpdateCompanyPack = (companyID, pack, type) => {
        // Kontrollo validimin e të dhënave hyrëse
        if (!companyID || !pack) {
            errorAlert("Ju lutem plotësoni të gjitha fushat.");
            return;
        }

        const updateData = {
            CompanyID: companyID,
            Pack: pack
        };

        // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
        axios.put(`${ApiLink.API_URL}${type === "pack" ? 'PackContoller' : 'PackContoller/module'}`, updateData, { headers })
            .then((response) => {
                if (response.status === 200) {
                    // handleSuccess(response.data); // Shfaq mesazhin e suksesit
                    setPack("");
                    setCompanyID("");
                    setOpenPackModal(false);
                    fetchData();
                }
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 400) {
                        errorAlert("Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri.");
                    } else if (error.response.status === 500) {
                        errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
                    } else {
                        errorAlert("Gabim i panjohur: " + error.response.data);
                    }
                } else {
                    errorAlert("Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë.");
                }
            });
    };

    const executeUpdatePack = (e, type) => {
        e.preventDefault();

        if (type === "pack") {
            handleUpdateCompanyPack(companyID, packName, "pack");
        } else {
            handleUpdateCompanyPack(companyID, packName, "module");
        }
    };


    //Per ta zgjedhur njesin e kompanis
    const handleAutocompleteChangePack = (event, value) => {
        if (value) {
            setPackID(value.PackID);
            setPackName(value.PackName);
        } else {
            setPackID("");
            setPackName('');
        }
    };

    const defaultPropsPack = {
        options: pack,
        getOptionLabel: (option) => option.PackName || ""
    };

    //Kodi per shfaqjen e tabeles ne Print
    const tableRef = useRef();

    //Kodi per pegination ne tabel
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Kodi per dizajnin e tabeles
    const styles = {
        tableHeader: {
            backgroundColor: '#284945',
            color: 'white',

        },
        tableCell: {
            paddingTop: '1px',
            paddingBottom: '1px',

        },

    };
    //Kodi per shfaqjen e loadingut 
    const [loading, setLoading] = useState(true);

    const handleDelete = async () => {
        try {
            const headers = authHeader();
            const response = await axios.delete(
                ApiLink.API_URL + 'Companies' + `/${deleteItemId}`,
                { headers }
            );

            // Kontrollo nëse fshirja ka ndodhur
            if (response.status === 200 && response.data === "Deleted Successfully") {
                deleteAlert("Kompania u fshi me sukses.");
                fetchData(); // Rifresko të dhënat pas fshirjes
            } else {
                deleteAlert("Kompania nuk mund të fshihet. Ekzistojnë varësi me të dhëna të tjera.");
            }
        } catch (error) {
            if (error.response) {
                // Nëse ka një përgjigje nga serveri
                if (error.response.status === 400 || error.response.status === 409) {
                    deleteAlert(error.response.data); // Shfaq mesazhin nga serveri
                } else if (error.response.status === 500) {
                    deleteAlert("Gabim serveri. Ju lutem provoni më vonë.");
                } else {
                    deleteAlert("Një gabim i panjohur ndodhi. Ju lutem provoni përsëri.");
                }
            } else {
                // Nëse nuk ka përgjigje (probleme rrjeti ose serveri është jashtë linje)
                deleteAlert("Nuk mund të lidhemi me serverin. Ju lutem kontrolloni lidhjen tuaj të internetit.");
            }
        } finally {
            setShowDeleteConfirmation(false); // Mbyll konfirmimin e fshirjes gjithmonë
        }
    };



    //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    const handleEdit = (item) => {
        setFormData({
            CompanyID: item.CompanyID,
            CompanyName: item.CompanyName,
            IdentificationNumber: item.IdentificationNumber,
            VATNumber: item.VATNumber,
            Address: item.Address,
            CityID: item.CityID,
            StateID: item.StateID,
            PhoneNumbers: item.PhoneNumbers,
            EdiPass: item.EdiPass,
            ARBKPass: item.ARBKPass,
            MailPass: item.MailPass,
            SMTPClient: item.SMTPClient,
            Email: item.Email,
            Comment: item.Comment,
            ModifiedByUser: loginEmail,
            VATDeclarant: item.VATDeclarant,
            FiscalYear: item.FiscalYear,
            IsActive: item.IsActive,
            CompanyLogo: item.CompanyLogo
        });
        setShowEditModal(true);
    };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!formData.IdentificationNumber) {
            errorAlert("Ju lutem plotësoni numrin Identifikues")
        }
        else {
            const headers = authHeader();
            axios
                .put(ApiLink.API_URL + 'Companies', formData, { headers })
                .then((response) => {
                    setShowEditModal(false); // Close the edit modal
                    fetchData();
                    updateAlert("Kompania është editua me sukses");
                })
                .catch((error) => {
                    // alert("Failed to update State");
                    errorAlert("Kompania nuk është edituar")
                });
        }
    };

    // const imageUpload = (e) => {
    //     e.preventDefault();

    //     // Kontrollo nëse files janë të definuara dhe ka një element në pozitën '0'
    //     if (e.target.files && e.target.files.length > 0) {
    //         const fileData = new FormData();
    //         fileData.append("file", e.target.files[0], e.target.files[0].name);

    //         axios.post(ApiLink.API_URL + 'Companies/SaveFile', fileData, { headers })
    //             .then((response) => {
    //                 setFormData({
    //                     ...formData,
    //                     CompanyLogo: response.data,
    //                 });
    //             })
    //             .catch((error) => {
    //                 console.error(error);
    //             });
    //     }
    // };

    const [showLogoAlert, setShowLogoAlert] = useState(false);
    const [showLogoTxt, setShowLogoTxt] = useState("");
    const imageUpload = (e) => {
        e.preventDefault();

        const file = e.target.files[0];
        if (!file) return;

        // Lista e ekstensioneve të lejuara për imazhe
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Kontrollo extensionin
        if (!allowedExtensions.includes(fileExtension)) {
            setShowLogoAlert(true);
            setShowLogoTxt('Ju lutem zgjidhni një file të vlefshëm të fotos (jpg, jpeg, png, gif, bmp, webp)');
            e.target.value = ''; // Pastron inputin
            return;
        }
        else {
            setShowLogoAlert(false);
            setShowLogoTxt("");
        }

        // Kontrollo edhe tipin MIME për më shumë siguri
        if (!file.type.startsWith("image/")) {
            setShowLogoAlert(true);
            setShowLogoTxt('File duhet të jetë një foto.');
            e.target.value = '';
            return;
        }
        else {
            setShowLogoAlert(false);
            setShowLogoTxt("");
        }

        const fileData = new FormData();
        fileData.append("file", file, file.name);

        axios.post(ApiLink.API_URL + 'Companies/SaveFile', fileData, { headers })
            .then((response) => {
                setFormData({
                    ...formData,
                    CompanyLogo: response.data,
                });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const fetchRole = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });

            if (response.data.UserRole && response.data.UserRole !== undefined) {
                setRole(response.data.UserRole);
            } else {
                errorAlert("Undefined Role.");
            }
        } catch (error) {
            console.error("Error fetching role:", error);
            // ... (pjesa tjetër e kodit)
        }
    };


    const filteredData = data.filter((item) => {
        return (
            item.CompanyName.toLowerCase().includes(searchTerm.toLowerCase())


        );
    });

    const fetchCityByState = async (stateID) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Cities/getcitybystate', { headers, params: { stateid: stateID } });
            setCity(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    useEffect(() => {
        const headers = authHeader();
        axios.get(ApiLink.API_URL + 'states', { headers })
            .then((response) => {
                setState(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    useEffect(() => {
        fetchData();
        fetchRole();
        fetchPack();
    }, [])

    return (
        <div>
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal_bootstrap show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal_bootstrap.Header>
                    <Modal_bootstrap.Title>Confirmation</Modal_bootstrap.Title>
                </Modal_bootstrap.Header>
                <Modal_bootstrap.Body>
                    <p>Are you sure you want to delete Company?</p>
                </Modal_bootstrap.Body>
                <Modal_bootstrap.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal_bootstrap.Footer>
            </Modal_bootstrap>

            {/* <Modal
                open={openPackModal}
                onClose={() => setOpenPackModal(false)}
                aria-labelledby="insert-modal-title"
                aria-describedby="insert-modal-description"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box sx={{ width: "30%", bgcolor: 'background.paper', borderRadius: '4px', boxShadow: 24, p: 4 }}>
                    {
                        insertType === "pack" ?
                            <p>Cakto pakon për këtë kompani</p>
                            :
                            <p>Cakto modulin për këtë kompani</p>
                    }
                    <hr></hr>
                    <FormControl sx={{ m: 1 }} variant="filled" style={{ width: "100%" }}>
                        <TextField
                            style={{ width: "100%" }}
                            id="outlined-read-only-input"
                            label="Kompania"
                            value={companyName}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </FormControl>
                   
                    <Autocomplete fullWidth sx={{ m: 1 }}
                        {...defaultPropsPack}
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack} // Shto funksionin onChange
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"}
                                variant="standard"
                            />
                        )}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
                        <MUI_Button variant="contained" color="secondary" onClick={() => { setOpenPackModal(false); }} sx={{ width: "45%" }}>Mbyll</MUI_Button>
                        <MUI_Button variant="contained" type="submit" onClick={(e) => { insertType === "pack" ? executeUpdatePack(e, "pack") : executeUpdatePack(e, "module") }} sx={{ width: "45%" }}>Ruaj</MUI_Button>
                    </Box>
                </Box>
            </Modal> */}
            <Modal
                open={openPackModal}
                onClose={() => setOpenPackModal(false)}
                aria-labelledby="insert-modal-title"
                aria-describedby="insert-modal-description"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        width: "30%",
                        bgcolor: 'background.paper',
                        borderRadius: '4px',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {insertType === "pack" ? (
                        <p>Cakto pakon për këtë kompani</p>
                    ) : (
                        <p>Cakto modulin për këtë kompani</p>
                    )}
                    <hr />
                    <FormControl sx={{ m: 1 }} variant="filled" style={{ width: "100%" }}>
                        <TextField
                            style={{ width: "100%" }}
                            id="outlined-read-only-input"
                            label="Kompania"
                            value={companyName}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </FormControl>
                    {/* <Autocomplete
                        fullWidth
                        sx={{ m: 1 }}
                        options={defaultPropsPack.options || []} // Kontrollo që options është një array
                        // getOptionLabel={(option) =>
                        //     typeof option === "string" ? option : option.name || ""
                        // }
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={
                                    insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"
                                }
                                variant="standard"
                            />
                        )}
                    /> */}
                    <Autocomplete
                        fullWidth
                        sx={{ m: 1 }}
                        {...defaultPropsPack}
                        id="include-input-in-list"
                        includeInputInList
                        onChange={handleAutocompleteChangePack}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={insertType === "pack" ? "Zgjedh Pakon" : "Zgjedh modulin"}
                                variant="standard"
                            />
                        )}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
                        <MUI_Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                setOpenPackModal(false);
                            }}
                            sx={{ width: "45%" }}
                        >
                            Mbyll
                        </MUI_Button>
                        <MUI_Button
                            variant="contained"
                            type="submit"
                            onClick={(e) =>
                                insertType === "pack"
                                    ? executeUpdatePack(e, "pack")
                                    : executeUpdatePack(e, "module")
                            }
                            sx={{ width: "45%" }}
                        >
                            Ruaj
                        </MUI_Button>
                    </Box>
                </Box>
            </Modal>



            {/* Shfaqja  e modalit per editimin e te dhenave  */}
            {showEditModal && (
                <div className="edit-modal" style={{ padding: "50px" }}>
                    <form onSubmit={handleSubmit}>
                        <h3>Ndryshimi i Kompanisë</h3>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5"># </span>
                            <input
                                className="form-control"
                                type="number"
                                id="CompanyID"
                                name="CompanyID"
                                value={formData.CompanyID}
                                onChange={handleInputChange}
                                disabled
                                autoComplete="off"
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Emri i Kompanisë</span>
                            <input
                                className="form-control"
                                type="text"
                                id="CompanyName"
                                name="CompanyName"
                                value={formData.CompanyName}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri Identifikues</span>
                            <input
                                className="form-control"
                                type="number"
                                id="IdentificationNumber"
                                name="IdentificationNumber"
                                value={formData.IdentificationNumber}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri i TVSH-së</span>
                            <input
                                className="form-control"
                                type="number"
                                id="VATNumber"
                                name="VATNumber"
                                value={formData.VATNumber}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Adresa</span>
                            <input
                                className="form-control"
                                type="text"
                                id="Address"
                                name="Address"
                                value={formData.Address}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text col-5 col-sm-5" htmlFor="stateSelect">Shteti </label>
                            <select
                                id="StateID"
                                name="StateID"
                                className="form-control"
                                value={formData.StateID}
                                onChange={(e) => { handleInputChange(e); fetchCityByState(e.target.value); }}
                            >
                                <option value="">-- Select State --</option>
                                {state.map((state) => (
                                    <option key={state.StateID} value={state.StateID}>
                                        {state.StateName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text col-5 col-sm-5" htmlFor="stateSelect">Qyteti </label>
                            <select
                                id="CityID"
                                name="CityID"
                                className="form-control"
                                value={formData.CityID}
                                onChange={handleInputChange}
                            >
                                <option value="">-- Select City --</option>
                                {city.map((cities) => (
                                    <option key={cities.CityID} value={cities.CityID}>
                                        {cities.CityName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Numri i Telefonit</span>
                            <input
                                className="form-control"
                                type="text"
                                id="PhoneNumbers"
                                name="PhoneNumbers"
                                value={formData.PhoneNumbers}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i sistemit të ATK-së</span>
                            <input
                                className="form-control"
                                type="text"
                                id="EdiPass"
                                name="EdiPass"
                                value={formData.EdiPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i sistemit të ARBK-së</span>
                            <input
                                className="form-control"
                                type="text"
                                id="ARBKPass"
                                name="ARBKPass"
                                value={formData.ARBKPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Email</span>
                            <input
                                className="form-control"
                                type="text"
                                id="Email"
                                name="Email"
                                value={formData.Email}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">SMTP Client</span>
                            <input
                                className="form-control"
                                type="text"
                                id="SMTPClient"
                                name="SMTPClient"
                                value={formData.SMTPClient}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Fjalkalimi i Email-it</span>
                            <input
                                className="form-control"
                                type="password"
                                id="MailPass"
                                name="MailPass"
                                value={formData.MailPass}
                                onChange={handleInputChange}
                                autoComplete="off"

                            />
                        </div>
                        <div className="p-2 w-50 bd-highlight">
                            <img style={{ width: "50px", height: "50px" }}
                                src={ApiLink.PHOTO_URL + formData.CompanyLogo} />
                            <input className="m-2" type="file" onChange={imageUpload} />
                            {
                                showLogoAlert && (
                                    <p style={{ color: "red" }}>{showLogoTxt}</p>
                                )
                            }
                        </div>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Komenti</span>
                            <textarea
                                className="form-control"
                                id="Comment"
                                name="Comment"
                                value={formData.Comment}
                                onChange={handleInputChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="IsActive">Deklarues i TVSH-së</label>
                            <input
                                type="checkbox"
                                id="VATDeclarant"
                                name="VATDeclarant"
                                checked={formData.VATDeclarant}
                                onChange={(event) =>
                                    setFormData({ ...formData, VATDeclarant: event.target.checked })
                                }
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="IsActive">Kompani Aktive</label>
                            <input
                                type="checkbox"
                                id="IsActive"
                                name="IsActive"
                                checked={formData.IsActive}
                                onChange={(event) =>
                                    setFormData({ ...formData, IsActive: event.target.checked })
                                }
                            />
                        </div>
                        <button type="submit" className="btn btn-success">Ndrysho</button>

                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowEditModal(false)}
                        >
                            Anulo
                        </button>
                    </form>
                </div>
            )}
            <div className="header_flexx">
                {/* <div className="header_icon">
                    <MdAddBusiness style={{}} className="header_icons" />
                    <h3>Lista e Kompanive</h3>
                </div> */}
                <TitleElements
                    icon={MdAddBusiness}
                    title="Lista e Kompanive"
                />
                {
                    role === "acctree" && (
                        <div style={{ display: "flex", gap: "10px" }}>
                            {/* <InsertData fetchData={fetchData} /> */}
                            <AddLinkButton
                                text="Krijo Kompani"
                                icon="bi bi-plus-circle"
                                link="/configuration/newCompany"
                            />
                            <AddLinkButton
                                text="Krijo Licens"
                                icon="bi bi-plus-circle"
                                link="/configuration/newLicense"
                            />
                        </div>
                    )
                }
            </div>
            {/* <div className="header_paragraph">
                <p>Forma e Kompanisë: Menaxhoni, editoni të dhënat e kompanisë sipas kërkeses.</p>
            </div> */}
            <ElementsParagraph text="Forma e Kompanisë: Menaxhoni, editoni të dhënat e kompanisë sipas kërkeses." />

            <div className="bordere">
                <div className="butonss">
                    {/* <div>
                        <button className="button-15" onClick={handleExportPDF} variant="contained"><AiOutlineFilePdf /> PDF </button>
                    </div>
                    <div className="butons15">
                        <button className="button-15" variant="contained" onClick={handlePrintTable}><AiOutlinePrinter /> Print</button>
                    </div> */}
                </div>
                <div className="searchboxx">
                    <div className="flexbox">
                        <div class="search">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search Companies"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}

                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr></hr>
            <Paper>
                <TableContainer sx={{ maxHeight: 500 }}>
                    <Table ref={tableRef} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={styles.tableHeader}><strong>#</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Emri i Kompanisë</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Numri Identifikues</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Numri i TVSH-së</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Adresa</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Viti Fiskal</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Pako</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Moduli</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Licensa</strong></TableCell>


                                {
                                    (role === "acctree" || role === "admin") && (
                                        <div>
                                            <TableCell sx={styles.tableHeader}><strong>Veprimet</strong></TableCell>
                                        </div>
                                    )
                                }
                            </TableRow>
                        </TableHead>
                        {loading ? (
                            <div className="spinner" style={{ marginLeft: "560px" }} ></div>
                        ) : (
                            <TableBody>
                                {filteredData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={item.CompanyID}>
                                            <TableCell sx={styles.tableCell}>{number + index}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.CompanyName}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.IdentificationNumber}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.VATNumber}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.Address}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.FiscalYear}</TableCell>
                                            <TableCell sx={styles.tableCell}>
                                                {
                                                    role === "acctree" ?
                                                        <>
                                                            {
                                                                item.Pack ?
                                                                    <>
                                                                        {item.Pack}
                                                                    </>
                                                                    :
                                                                    <Tooltip title="Cakto Pakon" placement="left" type="submit" onClick={() => setOpenPackModal(true)}>
                                                                        <AddIcon type="submit" onClick={() => { setInsertType("pack"); setOpenPackModal(true); setCompanyName(item.CompanyName); setCompanyID(item.CompanyID); }} />
                                                                    </Tooltip>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {item.Pack}
                                                        </>
                                                }
                                            </TableCell>
                                            <TableCell sx={styles.tableCell}>
                                                {
                                                    role === "acctree" ?
                                                        <>
                                                            {
                                                                item.Company_Module ?
                                                                    <>
                                                                        {item.Company_Module}
                                                                    </>
                                                                    :
                                                                    <Tooltip title="Cakto Pakon" placement="left" type="submit" onClick={() => setOpenPackModal(true)}>
                                                                        <AddIcon type="submit" onClick={() => { setInsertType("module"); setOpenPackModal(true); setCompanyName(item.CompanyName); setCompanyID(item.CompanyID); }} />
                                                                    </Tooltip>
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {item.Company_Module}
                                                        </>
                                                }
                                            </TableCell>
                                            <TableCell sx={styles.tableCell}>{item.licenseStatus}</TableCell>

                                            {
                                                role === "acctree" && (
                                                    <div>
                                                        <TableCell sx={styles.tableCell}>
                                                            <Tooltip title="Edit" placement="left">
                                                                <IconButton>
                                                                    <AiFillEdit style={{ color: '#466F86' }} onClick={() => { handleEdit(item); fetchCityByState(item.StateID); }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete" placement="right">
                                                                <IconButton>
                                                                    <DeleteIcon style={{ color: '#962a38' }}
                                                                        onClick={() => {
                                                                            setShowDeleteConfirmation(true);
                                                                            setDeleteItemId(item.CompanyID);
                                                                        }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </div>
                                                )
                                            }

                                            {
                                                role === "admin" && (
                                                    <div>
                                                        <TableCell sx={styles.tableCell}>
                                                            <Tooltip title="Edit" placement="left">
                                                                <IconButton>
                                                                    <AiFillEdit style={{ backgroundColor: '#284945' }} onClick={() => { handleEdit(item); fetchCityByState(item.StateID); }}
                                                                    />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </div>
                                                )
                                            }
                                        </TableRow>
                                    ))}
                            </TableBody>
                        )}
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
